import React from 'react';
import { dicNames, i18n } from '../lang/i18n';
import { CartProductItem } from '../store/Cart/CartModel';
import { LanguageCode } from './Conf';
export default class HelperProducts {
    public static ProductDescription(productExtras: any, product: CartProductItem) {
        const list: any[] = []

        if (product.preferences) {
            const ps = product.preferences;
            for (let x = 0; x < ps.length; x++) {
                const extra = productExtras[ps[x].extraId];
                switch (ps[x].type) {
                    case 'bool':
                        let lnKey = extra.conf.titles[LanguageCode + '_yes'] ? LanguageCode + '_' : 'es_';
                        if (ps[x].value) {
                            lnKey += 'yes';
                            list.push(<div key={x}>{extra.conf.titles[lnKey]} ({ps[x].price}€)</div>)
                        }
                        else {
                            lnKey += 'no';
                            list.push(<div key={x}>{extra.conf.titles[lnKey]} ({ps[x].price}€)</div>)
                        }
                        break;
                    case 'extras':
                        list.push(<div key={x}>{dicNames[ps[x].value]} ({ps[x].price}€)</div>)
                        break;
                    case 'list':
                        const extraList: any[] = extra.conf.list
                        const value = extraList.filter(_ => _.id === parseInt(ps[x].value));
                        list.push(<div key={x}>{extra.conf.titles[LanguageCode]} {value.length > 0 && value[0].name[LanguageCode]}</div>)
                        break;
                }
            }
        }

        if (product.discount > 0)
            list.push(<div>{i18n._Labels.Discount} {product.discount.toFixed(0)}%</div>)

        const title = product.product ? product.product.title : product.title;
        return <div style={{ flex: 1, flexDirection: 'column' }}>
            <div>({product.quantity}x) {title} ({product.priceBase}€)</div>
            {list}
        </div>

    }
    public static ProductDescriptionPrint(productExtras: any, product: CartProductItem) {
        const list: string[] = []
        const title = product.product ? product.product.title : product.title;

        list.push(`(${product.quantity}x) ${title} (${product.priceBase}€)`)

        if (product.preferences) {
            const ps = product.preferences;
            for (let x = 0; x < ps.length; x++) {
                const extra = productExtras[ps[x].extraId];
                switch (ps[x].type) {
                    case 'bool':
                        let lnKey = extra.conf.titles[LanguageCode + '_yes'] ? LanguageCode + '_' : 'es_';
                        if (ps[x].value) {
                            lnKey += 'yes';
                            list.push(`${extra.conf.titles[lnKey]} (${ps[x].price}€)`)
                        }
                        else {
                            lnKey += 'no';
                            list.push(`${extra.conf.titles[lnKey]} (${ps[x].price}€)`)
                        }
                        break;
                    case 'extras':
                        list.push(`${dicNames[ps[x].value]} (${ps[x].price}€)`)
                        break;
                    case 'list':
                        const extraList: any[] = extra.conf.list
                        const value = extraList.filter(_ => _.id === ps[x].value);
                        list.push(`${extra.conf.titles[LanguageCode]} ${value.length > 0 && value[0].name[LanguageCode]}`)
                        break;
                }
            }
        }

        if (product.discount > 0)
            list.push(`${i18n._Labels.Discount} ${product.discount.toFixed(0)}%`)

        return list;
    }
}